/**
 * Returns the string with the first letter capitalized.
 * @param {string} str
 * @returns {string}
 */
export function ucFirst(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Takes a string and returns only the letters, uppercase and separated with a dot.
 * @param {string} initials
 */
export function parseInitials(initials) {
    return initials
        ? initials
            .replace(/[^a-zA-Z]/g, "")
            .split("")
            .join(".")
            .toUpperCase() + "."
        : "";
}

/**
 * Returns the formal name using the given name parts.
 * @param {string} [initials]
 * @param {string} [firstName]
 * @param {string} [prefix]
 * @param {string} [lastName]
 * @returns {string|null}
 */
export function formalName(initials, firstName, prefix, lastName) {
    if (!initials && firstName) {
        initials = parseInitials(firstName.charAt(0));
    }
    const fullLastName = prefix && lastName ? `${prefix} ${ucFirst(lastName)}` : ucFirst(lastName);
    if (initials) {
        return `${parseInitials(initials)} ${fullLastName}`;
    }
    if (fullLastName) {
        return fullLastName;
    }
    return null;
}
